import styled from "styled-components";

import QiviaLogoFull from "../../assets/QiviaLogoFull.svg?react";
import { StyledFlex } from "./layout";

export const Brand = () => (
  <StyledBrand>
    <QiviaLogoFull />
  </StyledBrand>
);

const StyledBrand = styled(StyledFlex)`
  color: inherit;

  svg {
    height: 1.5rem;
    width: auto;
  }

  path {
    fill: currentColor;
  }
`;
